import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import styles from "./Logout.module.css";

const theme = createTheme();

const UnauthorizedErrorPage = () => {
  return (
    <div className={styles.background}>
      <ThemeProvider theme={theme}>
        <Container
          component="main"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
          }}
        >
          <CssBaseline />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fcfafa',
              padding: '40px',
              borderRadius: '20px',
              width: '100%',
              maxWidth: '700px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              textAlign: 'center',
            }}
          >
            <img src="/logo192.png" className={styles.logo} alt='logo' />
            <Box sx={{ mt: 1 }}>
              <Typography
                component='div'
                sx={{ fontFamily: 'unset' }}
              >
                <strong>
                  Your account is not authorized to use this app. Please contact the administrator.
                </strong>
              </Typography>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default UnauthorizedErrorPage;